import {useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {UPDATE_ALIPAY_PLUS_WALLET_DETAILS} from '../../v2/actions/action-types';
import getAlipayPlusWalletDetails from '../../v2/api/getAlipayPlusWalletDetails';
import {getSiteDataV2} from '../../v2/selectors/selectors';
import Track from '../../v2/utils/tracking';

export default function AlipayPlusOptionsLoader() {
  const localeCode = useSelector(state => getSiteDataV2(state).locale);
  const dispatch = useDispatch();
  
  const getAlipayPlusWalletDetailsFromAPI = useCallback(async () => {
    const alipayPlusDetails = await getAlipayPlusWalletDetails(localeCode, dispatch);
    return alipayPlusDetails;
  }, [localeCode, dispatch]);
  
  useEffect(() => {
    getAlipayPlusWalletDetailsFromAPI()
      .then((details) => {
        if (details === null) {
          Track.track('Alipay Plus session endpoint returned null from checkout-api');
        } else if (details && Object.keys(details)?.length && Object.keys(details)?.length !== 0) {
          dispatch({
            type: UPDATE_ALIPAY_PLUS_WALLET_DETAILS,
            paymentOptionType: 'ALIPAY_PLUS',
            details,
          });
        }
      }).catch((error) => {
        Track.track(error);
      });
  }, [localeCode, dispatch, getAlipayPlusWalletDetailsFromAPI]);
  
  return null;
}
